import { QueryDocumentSnapshot } from "@atgof-firebase/firebase";
import React, { useContext } from "react";
import { useNavigation } from "@react-navigation/native";
import ListItem from "../ListItem";
import { sheetSubjectCollection } from "../../data/sheet";
import { useProject } from "../../data/useProject";
import ListPage from "./ListPage";
import { CollectionListProps, CollectionListSpec } from "../CollectionList";
import {
  SheetSubjectKind,
  SheetSubject,
  compareSheetSubject,
  toSheetSubject,
  searchTokensForSheetSubject,
  labelForSheetSubject,
} from "../../common/sheet-subject";
import { NavPageProps } from "./NavPage";
import { LanguageContext } from "@atgof-common/language";
import { formatDate } from "@atgof-common/util";
import { View } from "react-native";
import FixtureLabel from "@atgof-common/FixtureLabel";
import { Text } from "react-native-paper";
import { useDocument } from "../../data/useDocument";

export default function SheetSubjectListPage({
  kind,
  pinnedSubjects,
  ...props
}: {
  kind: SheetSubjectKind;
  pinnedSubjects?: string[];
} & NavPageProps<any> &
  Partial<CollectionListProps>) {
  const navigation = useNavigation();
  const project = useProject();
  const hideDisplayIds = useDocument(project)?.get("hideSubjectDisplayIds")
    ? true
    : false;
  const { ph } = useContext(LanguageContext);
  function renderSubject({ item }: { item: SheetSubject }) {
    const { id, displayName, performerKind, firstDay, lastDay } = item;
    return (
      <ListItem
        label={labelForSheetSubject(item)}
        onPress={() =>
          navigation.navigate("sheetSubjectDetail", {
            id,
            subjectKind: kind,
            subjectName: displayName,
            performerKind,
          })
        }
      >
        <View
          style={{
            flexDirection: "row",
            marginTop: 8,
            marginLeft: 32,
            gap: 32,
          }}
        >
          {[
            { k: "start", v: firstDay },
            { k: "end", v: lastDay },
          ].map(({ k, v }) =>
            v ? (
              <View
                style={{ flexDirection: "row", gap: 6, alignItems: "center" }}
              >
                <FixtureLabel small text={ph(k) as string} />
                <Text>{formatDate(v.toDate())}</Text>
              </View>
            ) : null,
          )}
        </View>
      </ListItem>
    );
  }
  const [collections, setCollections] =
    React.useState<CollectionListSpec<SheetSubject, void>[]>();
  React.useEffect(() => {
    setCollections(
      project
        ? [
            {
              collection: sheetSubjectCollection(project, kind),
              addConstraints: (q) => q.orderBy("displayName", "asc"),
              process: (docs: QueryDocumentSnapshot[]) => {
                const all = docs.map((item) =>
                  toSheetSubject(item, pinnedSubjects, hideDisplayIds),
                );
                return [
                  ...all.filter((item) => item.isPinned),
                  ...all.filter((item) => !item.isPinned),
                ].sort(compareSheetSubject);
              },
              renderItem: renderSubject,
              searchTokens: searchTokensForSheetSubject,
            },
          ]
        : undefined,
    );
  }, [project?.path, kind, pinnedSubjects?.join("\n"), hideDisplayIds]);

  return (
    <ListPage {...props} collections={collections} estimatedItemSize={52} />
  );
}
